import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import "./MainTeacherPage.sass"
import TeacherGrid from "../../_components/teacher/TeacherGrid";
import {ADDRESS} from "../../_api/client";
import InformationBlock from "../../_containers/infoblock/InformationBlock";
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import moment from "moment";
import {useNavigate} from "react-router";
import {getNextLesson, sendImage} from "../../_actions/auth/authService";
import {removeLesson} from "../../_actions/auth/authReducer";
import {red} from "../../common/colors";

export default function MainTeacherPage() {
    const {firstName, lastName, middleName, courses, img, lesson} = useSelector(state => state.auth.current)
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!lesson) {
            dispatch(getNextLesson())
        }
    }, [lesson, dispatch])
    useEffect(() => {
        document.title = 'КьюАй - Профиль'
        return () => dispatch(removeLesson())
    }, [])

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            let formData = new FormData();
            formData.append("file", event.target.files[0]);

            dispatch(sendImage(formData));
        }
    }

    const renderLessonDate = () => {
        let isExpired = false;
        let result = "нет следующего урока";

        if (lesson) {
            isExpired = moment(`${lesson.date} ${lesson.time}`, "YYYY-MM-DD HH:mm:SS")
                .hour(2)
                .isBefore(moment.now())

            result = moment(`${lesson.date} ${lesson.time}`, "YYYY-MM-DD HH:mm:SS").calendar();

            if (isExpired) {
                result += " Завершите урок!"
            }
        }

        return <div style={isExpired ? {color: red, fontWeight: 'bold'} : {}} className="MainTeacherPage-info-user-lesson"
                    title="Перейти в группу"
                    onClick={lesson
                        ? () => navigate(`/home/group/${lesson.groupId}`)
                        : () => {}}>
            {result}
        </div>
    }

    return (
        <div className="MainTeacherPage-wrapper">
            <InformationBlock>
                <div className="MainTeacherPage-info-block">
                    <div className="MainTeacherPage-info-img-block">
                        <div className="MainTeacherPage-info-img">
                            {img ? <img src={`${ADDRESS}/avatar/${img}`} alt={`${lastName} ${firstName}`} /> : <PersonAddAltOutlinedIcon/>}
                        </div>
                        <div className="MainTeacherPage-info-img-button-panel">
                            <label htmlFor="img-id" className="MainTeacherPage-info-img-label">Загрузить фото</label>
                            <input id="img-id"
                                   accept="image/png, image/jpeg"
                                   name="file"
                                   onChange={onImageChange}
                                   className="MainTeacherPage-info-img-button" type="file"/>
                        </div>
                    </div>
                    <div className="MainTeacherPage-info-main">
                        <div className="MainTeacherPage-info-name-panel">
                            <div className="MainTeacherPage-info-name">
                                {`${lastName} ${firstName} `} {middleName && middleName}
                            </div>
                        </div>
                        <div className="MainTeacherPage-info-user">
                            <div className="MainTeacherPage-info-user-item">
                                <SchoolOutlinedIcon/>
                                <div>
                                    <b>Курсы:</b>
                                    <div>{courses && courses.map(course => course.name).join(", ")}</div>
                                </div>
                            </div>
                            <div className="MainTeacherPage-info-user-item">
                                <AccessTimeOutlinedIcon/>
                                <div>
                                    <b>Следующий урок:</b>
                                    {renderLessonDate()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </InformationBlock>
            <TeacherGrid/>
        </div>
    )
}